<div class="login-page">
  <div class="background-login">
    <div class="shape">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1440 120">
        <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
      </svg>
    </div>
  </div>
  <div id="login" class="pb-5">
    <div class="login">
      <form [formGroup]="codeValidateForm" (ngSubmit)="submitCode()" class="login-form p-5">
        <div class="form-group">
          <div class="logo-entity mb-3 text-center">
            <img src="{{entityLogo}}" width="60">
          </div>
        </div>
        <div class="form-group mb-4">
          <label class="mt-2 mb-4">{{'t-code-validation-text' | translate}}</label>
          <ng-otp-input [ngClass]="{
                    'is-invalid': submited && form['code'].errors
                  }" (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
          <!-- <input type="code" formControlName="code" [ngClass]="{
                      'is-invalid': submited && form['code'].errors
                    }" class="form-control" name="code" id="code"> -->
          <div *ngIf="submited && form['code'].errors" class="invalid-feedback">
            <div *ngIf="form['code'].errors['required']">
              {{'t-code-validation' | translate}}
            </div>
            <div *ngIf="form['code'].errors['codeError']">
              {{'t-code-validation-error' | translate}}
            </div>
          </div>
          <i class="icon_mail_alt"></i>
        </div>
        <button class="btn white w-100 submit-button" type="submit"
          [attr.disabled]="isDisabled || btnDisabled ? '' : null">
          <span *ngIf="!isDisabled ">{{'t-submit' | translate}}</span>
          <span class="d-flex justify-content-center" *ngIf="isDisabled">
            <span class="me-2">
              {{'t-submit' | translate}}...
            </span>
            <span class="spinner-border flex-shrink-0" role="status">
              <span class="visually-hidden">{{'t-submit' | translate}}...</span>
            </span>
          </span>
        </button>
        <div class="mt-3 text-center">
          <p *ngIf="!resendDisabled" class="mb-0">{{'t-code-didnt-receive' | translate}} <a (click)="resendCode()"
              class="cursor-pointer fw-semibold text-primary text-decoration-underline">{{'t-resend'
              | translate}}</a> </p>
          <p *ngIf="resendDisabled" class="mb-0">{{'t-wait-seconds' | translate:
            {resendTime: resendTime} }}</p>
        </div>
      </form>
    </div>
  </div>
</div>
